import Scenario2Part1 from './Scenario2Part1';
import GameManager from '../../cvp-webgames-core/GameManager';
import { constants } from '../../misc/constants';
import BaseScenarioPart from '../../cvp-webgames-core/Scenario/BaseScenarioPart';
import { VideoEnvironmentProps } from '../../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import { CalmBaseScenario } from '../CalmBaseScenario';
import Scenario2Part2 from './Scenario2Part2';
import Scenario2Part3 from './Scenario2Part3';
import Scenario2Part4 from './Scenario2Part4';

export default class Scenario2 extends CalmBaseScenario {
	parts: BaseScenarioPart<CalmBaseScenario>[] = [
		new Scenario2Part1(this, () => {this.goToPart2()}),
		new Scenario2Part2(this, () => {this.goToPart3()}),
		new Scenario2Part3(this, () => {this.goToPart4()}),
		new Scenario2Part4(this, () => {this.goToScenarioEnd()})
	]
	public get totalNumberOfQuestions(): number {
		return 5;
	}

	public getEnvironmentProps(): VideoEnvironmentProps {
		return {
			controls: false,
			autoBlur: true
		};
	}

	public policyResponse = false;

	public get currentLevel(): number {
		return 1;
    }
	
	constructor(gameManager: GameManager, scenarioName: string) {
		super(gameManager, scenarioName);
	}

	public getParts(): BaseScenarioPart<CalmBaseScenario>[] {
		return this.parts;
	}

	public getSoundPath(fileName: string): string {
		return './assets/audio/scenario2/' + fileName + '.mp3';
	}

	start() {
        this.gameManager.UiManager.createUIInstance(constants.uiNames.SplashScreenUI);
		this.goToPart1();
	}

	goToPart1() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part1.id, () => {
			this.destroyAllUIInstances();
		});
	}

	goToPart2() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part2.id);
	}

	goToPart3() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part3.id);
	}

	goToPart4() {
		this.loadPart(constants.scenarios.scenario2.parts.level2Part4.id);
	}

	goToScenarioEnd() {
	}
}